/*
 * @Author: <pcjser> 
 * @Date: 2018-04-19 09:12:36 
 * @Last Modified by: pcjser
 * @Last Modified time: 2018-06-11 15:28:15
 */
export const platformSet = (params, cb) => {
  let ua = window.navigator.userAgent.toLowerCase()
  let plat = '';
  switch (true) {
    case (ua.match(/MicroMessenger/ig) !== null):
      plat = 'wechat';
      break;
    case (ua.match(/anfeng_mobile_ios_fengwan/ig) !== null):
      plat = 'fengwanI';
      break;
    default:
      plat = 'browser';
      break;
  }
  window.localStorage.setItem(params, plat);
  cb && cb(plat)
};

export const equipmentSet = params => {
  let ua = window.navigator.userAgent.toLowerCase();
  let equipment = '';
  switch (true) {
    case (ua.match(/iphone|ipod|ipad/ig) !== null):
      equipment = 'iOS';
      break;
    case (ua.match(/android/ig) !== null):
      equipment = 'android';
      break;
    default:
      equipment = 'pc';
      break;
  }
  window.localStorage.setItem(params, equipment);
};

export const Unit = option => {
  const _option = {
    remUnit: 75,
    remPrecision: 6,
  };

  option = Object.assign({}, _option, option)

  return x => {
    return parseFloat((x / option.remUnit).toFixed(option.remPrecision)).toString() + 'rem'
  }
};

export const Rem = Unit({
  remUnit: 75
});

export const getQueryString = (key, search) => {
  // let queryArr = window.location.href.replace("?from=singlemessage", "").split('?')
  // let search = '?' + queryArr[queryArr.length - 1]
  let result = search.match(new RegExp("[?&]" + key + "=([^&]+)", "i"));
  if (result == null || result.length < 1) {
    return "";
  }
  return result[1];
}



// WEBPACK FOOTER //
// ./src/service/utils.js